import * as React from 'react';

const CoworkingDayPass = () => {
  return <div />;
};

export default CoworkingDayPass;
